import {Module, Component} from 'app/decorators';
import R from 'app/resource';
import customerTpl from './customers.compontent.html';

import CustomerCardComponent from './customer.card.component';


@Module({
    name: "app.orders.compontents.customersSplitList",
    modules: [
        R,
        CustomerCardComponent,
    ],
})
@Component({
    selector: 'blnd-customer-split-list',
    template: customerTpl,
    bindings: {
        ngModel: '=',
        mode: '@',
        number: '@',
    },
})
export default class CustomersSplitList {
    addCustomer () {
        if (!this.canAdd) { return; }

        this.ngModel.push({
            percentage: 50
        });
    }

    get canAdd() {
        return this.ngModel.length < 1;
    }

    removeCustomer (customer) {
        let index = this.ngModel.indexOf(customer);
        this.ngModel.splice(index, 1);
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/billing/customers.component.js